import type {AllowedNonCommentReviewType} from '../../page-data/payloads/toolbar'
import type {PullRequestState} from '../../types'
import {isReviewablePullRequestState} from './is-reviewable-pull-request-state'

export type ReviewMode = 'comments' | 'review'

export function getAllowedReviewMode({
  viewerIsAuthor,
  viewerAllowedNonCommentReviewTypes,
  pullRequestState,
}: {
  viewerIsAuthor: boolean
  viewerAllowedNonCommentReviewTypes: AllowedNonCommentReviewType[]
  pullRequestState: PullRequestState
}): ReviewMode {
  const viewerCanApprove = viewerAllowedNonCommentReviewTypes.includes('APPROVE')
  const viewerCanRequestChanges = viewerAllowedNonCommentReviewTypes.includes('REQUEST_CHANGES')
  const isInReviewableState = isReviewablePullRequestState(pullRequestState)

  switch (true) {
    case !isInReviewableState:
      return 'comments'
    case viewerIsAuthor:
    case viewerCanApprove:
    case viewerCanRequestChanges:
      return 'review'
    default:
      return 'comments'
  }
}
